// extracted by mini-css-extract-plugin
export default {"form-top-buttons":"TopButtons_form-top-buttons__11NCn"};